<template>
  <div>
    <div class="container-flex m-3">
      <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
      <div class="row">
        <div class="col-lg-12 text-left">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2 text-left">
          <b-card class="sticky">
            <h1 class="filterHeader">Filter</h1>
            <b-form-group label="Experience Type" label-class="font-weight-bold" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                id="experience-types-checkbox-group"
                v-model="experienceTypesSelected"
                :options="experienceTypesOptions"
                class="mb-4"
                :aria-describedby="ariaDescribedby"
                name="experienceTypes group"
                style="column-count: 1"
                stacked
                @change="handleFilterChange"
              ></b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="Region" label-class="font-weight-bold" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                id="regions-checkbox-group"
                v-model="regionsSelected"
                :options="regionsOptions"
                class=""
                :aria-describedby="ariaDescribedby"
                name="regions group"
                style="column-count: 1"
                stacked
                @change="handleFilterChange"
              ></b-form-checkbox-group>
            </b-form-group>
          </b-card>
        </div>
        <div class="col-lg-10 text-left">
          <b-card>
            <div class="row">
              <div class="col-lg-4">
                <h1 class="roadtripsFilterHeader">Road Trips</h1>
              </div>
              <div class="col-lg-8 text-right">
                <b-button id="newRoadtripBtn" variant="secondary" class="mt-3" @click="$router.push('roadtrips/create')">+ New Roadtrip</b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <article class="col-lg-4" v-for="(trip, index) in $store.state.roadtrips.roadtrips.trips" :key="index">
                    <router-link :to="{ name: 'roadtrip edit', params: { roadtripId: trip._id } }" class="edit-page-link">
                      <div class="roadtrip-wrapper">
                        <!-- <figure class="roadtrip-thumb" :style="{ 'background-image': 'url('+trip.mainImage+')'}" role="presentation">
                                </figure> -->
                        <figure role="presentation">
                          <img
                            :src="trip.mainImage"
                            class="roadtrip-thumb"
                            alt="roadtrip main image"
                            @error="stagingImageBucketFallBack($event, trip.mainImage)"
                          />
                        </figure>
                        <div class="roadtrip-info">
                          <div class="row">
                            <div class="col-sm-8 infoText">
                              <div class="infoTitle">ROAD TRIP</div>
                              {{ trip.title }}
                            </div>
                            <div class="col-sm-4 text-center">
                              <div class="infoTitleTripNumber">TRIP NUMBER</div>
                              <div class="tripNumber">{{ trip.tripId }}</div>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-sm-8">
                              <div class="infoTitle">REGIONS</div>
                              <div class="infoText">{{ trip.regions.join(', ') }}</div>
                            </div>
                            <div class="col-sm-4 text-center">
                              <div class="infoTitlePoints">POINTS</div>
                              <div class="infoTitlePointsValue">{{ trip.points_of_interest }}</div>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-sm-8">
                              <div class="infoTitle">TYPE</div>
                              <div class="infoText">{{ trip.experience_types.join(', ') }}</div>
                            </div>
                            <div class="col-sm-4 text-center">
                              <div class="infoTitleStatus">STATUS</div>
                              <div class="infoTitleStatusValue">{{ JSON.parse(trip.active.toLowerCase()) === true ? 'Active' : 'Inactive' }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </article>
                </div>
                <div class="pagination justify-content-center">
                  <b-pagination
                    v-if="$store.state.roadtrips.fullCount > 0"
                    :value="$store.state.roadtrips.page.page"
                    :total-rows="$store.state.roadtrips.fullCount"
                    :per-page="$store.state.roadtrips.page.pageSize"
                    :hide-ellipsis="true"
                    @change="changePage"
                  />
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import Loading from 'vue-loading-overlay';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      roadtrips: [],
      experienceTypesSelected: [],
      experienceTypesOptions: [
        { text: 'Arts & Culture', value: 'Art and Culture' },
        { text: 'Beaches', value: 'Beach' },
        { text: 'Civil Rights Legacy', value: 'Civil Rights' },
        { text: 'Food & Drink', value: 'Food' },
        { text: 'History', value: 'History' },
        { text: 'Music', value: 'Music' },
        { text: 'Outdoors', value: 'Outdoor' },
        { text: 'Science & Discovery', value: 'Science and Discover' },
        { text: 'Sports', value: 'Sports' },
        { text: 'Year of Golf', value: 'Golf' },
      ],
      regionsSelected: [],
      regionsOptions: [
        { text: 'North', value: 'North Alabama' },
        { text: 'South', value: 'South Alabama' },
        { text: 'Central', value: 'Central Alabama' },
        { text: 'Gulf Coast', value: `Beaches ${encodeURIComponent('&')} Gulf Coast` },
      ],
      Breadcrumbs: [
        {
          text: 'Content',
          active: true,
        },
        {
          text: 'Road Trips',
          href: '/roadtrips',
          active: true,
        },
      ],
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await Promise.all([this.getRoadtrips()]);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    async getRoadtrips() {
      await this.$store.dispatch('roadtrips/getRoadtrips');
      this.roadtrips = this.$store.state.roadtrips.roadtrips;
    },
    async handleFilterChange() {
      this.$nextTick(() => {
        this.changePage(1);
      });
    },
    async changePage(page) {
      try {
        this.isLoading = true;
        const selected = [];
        selected.experienceTypes = this.experienceTypesSelected;
        selected.regions = this.regionsSelected;
        await this.$store.dispatch('roadtrips/setPage', {
          page,
          selected,
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async stagingImageBucketFallBack(e, img) {
      // if initial onload image is not avail, we roll to the staging onload image.
      // if an image is still not found, we use a placeholder image. This  prevents
      // and endless loop on error because cant find image in production or staging.
      const modifiedLink = img.replace('alabama-travel', 'staging-alabama-travel');

      const imageExists = await this.testImage(modifiedLink);

      if (imageExists) {
        e.target.src = modifiedLink;
      } else {
        e.target.src = 'https://via.placeholder.com/200/300';
      }
    },
    testImage(url) {
      if (!url || typeof url !== 'string') return Promise.resolve(false);
      return new Promise((resolve) => {
        const imgElement = new Image();
        imgElement.addEventListener('load', () => resolve(true));
        imgElement.addEventListener('error', () => resolve(false));
        imgElement.src = url;
      });
    },
  },
};
</script>

<style scoped>
.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
.roadtrip-wrapper {
  background-color: white;
  border: 1px solid #4e97b2;
  margin-bottom: 50px;
  padding: 0 0 5px;
  min-height: 380px;
}

.edit-page-link {
  color: inherit;
}

.roadtrip-thumb {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 160px;
  position: relative;
}

.roadtrip-info {
  padding: 0 20px 20px 20px;
  text-align: left;
  /* @media only screen and (min-width: 1024px) {
  padding-bottom: 25px;
  } */
}

.infoText {
  line-height: 1.1;
}

.infoTitle {
  color: grey;
  font-size: 70%;
  letter-spacing: -1px;
}
.infoTitleTripNumber {
  color: grey;
  font-size: 70%;
  letter-spacing: -1px;
}
.tripNumber {
  color: black;
  font-size: 100%;
  letter-spacing: -1px;
  font-weight: bold;
}
.infoTitleStatus {
  color: grey;
  font-size: 70%;
  letter-spacing: -1px;
}
.infoTitleStatusValue {
  color: black;
  font-size: 100%;

  font-weight: bold;
}
.infoTitlePoints {
  color: grey;
  font-size: 70%;
  letter-spacing: -1px;
}
.infoTitlePointsValue {
  color: black;
  font-size: 100%;
  letter-spacing: -1px;
  font-weight: bold;
}
</style>
